import { Role } from 'types';

type Store = {
  runtimeConfig: {
    config?: {
      videoDeliveryPipelineFeatureIsEnabled?: boolean,
      videoDeliveryPipelineFeatureIsEnabledOnlyInternally?: boolean
    }
  },
  account: {
    currentAccount?: {
      email: string
    },
    roles?: Array<Role>
  }
};

export function isEnableEntertainmentVideoSelector(
  {
    runtimeConfig,
    account
  }: Store
) {
  const isFeatureEnabled = runtimeConfig.config?.videoDeliveryPipelineFeatureIsEnabled ?? false;
  const isFeatureEnabledOnlyInternally = runtimeConfig.config?.videoDeliveryPipelineFeatureIsEnabledOnlyInternally ?? true;
  const hasModeratorRole = account.roles?.includes('ENTERTAINMENT_VIDEO_MODERATOR') || account.roles?.includes('ADMIN');

  if (!isFeatureEnabled || !hasModeratorRole) {
    return false;
  }

  if (!isFeatureEnabledOnlyInternally) {
    return true;
  }

  const email = account.currentAccount?.email ?? '';
  return email.includes('@zalando.');
}
